import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/ap-logo.svg'


const _hoisted_1 = { class: "pane" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "centered",
  src: _imports_0,
  style: {"max-width":"300px"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "vertical-margin" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_step = _resolveComponent("el-step")
  const _component_el_steps = _resolveComponent("el-steps")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, { id: "geotab-setup-view" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_main, null, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createVNode(_component_el_steps, {
              active: _ctx.currentState,
              "align-center": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_step, { title: "Welcome" }),
                _createVNode(_component_el_step, { title: "Legal Stuff" }),
                _createVNode(_component_el_step, { title: "Organization Setup" }),
                _createVNode(_component_el_step, { title: "User Sync" }),
                _createVNode(_component_el_step, { title: "Onboard Drivers" }),
                _createVNode(_component_el_step, { title: "Done" })
              ]),
              _: 1
            }, 8, ["active"]),
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComp), { onNext: _ctx.onNext }, null, 8, ["onNext"]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}